var base = require('settings/security/update-password');

Vue.component('spark-update-password', {
  mixins: [base],
  data() {
    return {
      form: new SparkForm({
        current_password: '',
        password: '',
        password_confirmation: ''
      }),
      alertMsg: null
    };
  },
  methods: {
    /**
     * Update the user's password.
     */
    update() {
      var vm = this;
      Spark.put('/settings/password', this.form).then(function() {
        vm.alertMsg = 'Successfully updated!';
        vm.form = new SparkForm({
          current_password: '',
          password: '',
          password_confirmation: ''
        });
      }, function() {
        vm.alertMsg = 'Error trying to update password.';
      });
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/security/update-password.js